import React, { Component } from 'react';
import Notificacao from '../Notificacao';
import moment from 'moment';
import { getCidadebyId } from '../../Libs/cidade';

import logo from '../../assets/images/logo-global-brain.png'

import PrintTemplate from 'react-print';
export default class Receituario extends Component {
  state = {
    comentario: '',
    ref: null,
    alertMsg: null,
    status: null,
    openModal: false,
    cidade: '',
    paciente: null,
    NomeCidade: ''
  };
  componentDidMount() {
    getCidadebyId(this.props.item.profissional.cidade).then(cidade => {
      this.setState({ NomeCidade: cidade.cidade });
    });
  }
  // componentDidMount(){
  //   getCidadebyId(this.props.item.profissional.cidade)
  //   .then(cidade => {
  //    this.setState({NomeCidade: cidade.cidade})
  //  }
  // }
  _setImprimir = () => {
    window.print();
  };
  render() {
    

    return (
      <div>

            
        
        <PrintTemplate>
            <center>
            <img src={logo} alt="" height="70" />
             
              <h4>{`${this.state.NomeCidade}`}</h4>
            </center>
            <br />
            {this.props.item.receituario && this.props.item.receituario.prescricao ? 
            <p>{`Primeiro Remédio: ${this.props.item.receituario.prescricao}`}</p>
           : null }
           
            <center>
              <div>
              <p>
                <br />
                {moment(
                  this.props.item.receituario.DataCriacao,
                  'DD-MM-YYYY'
                ).format('DD/MM/YYYY')}
              </p>
              <p>{this.props.item.profissional.nome}<br />
            {`CRM: ${this.props.item.profissional.crm}`}</p>
              </div>
            </center>
        
        </PrintTemplate>

             
      
        <div
          id="react-no-print"
          className="container"
          style={{
            overflowY: 'scroll',
            overflowX: 'hidden',
            maxHeight: '80vh'
          }}
        >
        
          <div className="col">
            <center>
             
              <h4>{`${this.state.NomeCidade}`}</h4>
            </center>
            <br />
            {this.props.item.receituario.prescricao ? 
            <p>{`Primeiro Remédio: ${this.props.item.receituario.prescricao}`}</p>
           : null }
           
            <center>
              <div>
              <p>
                <br />
                {moment(
                  this.props.item.receituario.DataCriacao,
                  'DD-MM-YYYY'
                ).format('DD/MM/YYYY')}
              </p>
              <p>{this.props.item.profissional.nome}<br />
            {`CRM: ${this.props.item.profissional.crm}`}</p>
              </div>
            </center>
          </div>
          <br />
   
      
        {this.state.notifition ? (
            <Notificacao
              msg={this.state.msg}
              nameclass={this.state.nameclass}
            />
          ) : null}
         <div className="col-sm-10" style={{ maxWidth: '76%' }}>
            <div className="form-group">
              <br />
              <button
                style={{ float: 'right' }}
                onClick={() => this._setImprimir()}
                type="button"
                className="btn waves-effect waves-light btn-info"
              >
                Imprimir
              </button>
              <br />

            </div>

           
          </div>

          
        </div>    
      </div>
    );
  }
}
